// ============================================================================
// plot/grid.ts — graduations « jolies » (1/2/5 × 10^n) pour grille + axes.
// PUR & testable.
// ============================================================================

/** Pas « joli » couvrant `range` en ~`target` graduations : 1, 2 ou 5 × 10^n. */
export function niceStep(range: number, target = 8): number {
  const raw = Math.max(range, 1e-9) / target;
  const p = Math.pow(10, Math.floor(Math.log10(raw)));
  const m = raw / p;
  const nice = m < 1.5 ? 1 : m < 3 ? 2 : m < 7 ? 5 : 10;
  return nice * p;
}

/** Graduations de `min` à `max` au pas `step`, le quasi-zéro étant remis à 0. */
export function ticks(min: number, max: number, step: number): number[] {
  if (step <= 0) return [];
  const eps = step * 1e-6;
  const start = Math.ceil(min / step - 1e-6) * step;
  const n = Math.floor((max - start) / step + 1e-6);
  const out: number[] = [];
  for (let i = 0; i <= n; i++) {
    const v = start + i * step;
    out.push(Math.abs(v) < eps ? 0 : v);
  }
  return out;
}

/** Libellé court d'une graduation (sans zéros traînants). */
export function formatTick(v: number): string {
  return Number(v.toFixed(3)).toString();
}

/**
 * Graduation écrite à la française : virgule décimale, espace fine insécable des milliers, vrai signe
 * moins (« 0,5 », « 10 000 », « −2 »). Les graphes des énoncés l'affichent ainsi.
 */
export function frenchTick(v: number): string {
  const n = Number(v.toFixed(3));
  const [int, dec] = Math.abs(n).toString().split('.');
  const grouped = Math.abs(n) >= 1000 ? int!.replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f') : int!;
  return `${n < 0 ? '−' : ''}${grouped}${dec ? `,${dec}` : ''}`;
}
